import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { DigitalAssistantService } from '../../../digital-assistant.service';

import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'miq-chat-bot-header',
  templateUrl: './chat-bot-header.component.html',
  styleUrl: './chat-bot-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon],
})
export class ChatBotHeaderComponent {
  readonly emitToggleMinimize = output();
  readonly emitNewSession = output<void>();
  readonly emitWindowSize = output<boolean>();
  readonly emitCloseChat = output<void>();
  readonly showBackBtn = input(false);
  readonly showMenuBtn = input(false);
  readonly windowSizeIncreasedInput = input(true, { alias: 'windowSizeIncreased' });
  windowSizeIncreased = true;
  readonly showTitle = input(true);
  readonly pageTitle = input('');
  readonly isInprogress = input(false);
  readonly showCloseBtn = input(true);

  private readonly chatBotService = inject(DigitalAssistantService);

  constructor() {
    // Sync input → local mutable property
    const self = this;
    const inputRef = this.windowSizeIncreasedInput;
    Promise.resolve().then(() => { self.windowSizeIncreased = inputRef(); });
  }

  toggleWindowSize(): void {
    this.windowSizeIncreased = !this.windowSizeIncreased;
    this.emitWindowSize.emit(this.windowSizeIncreased);
  }

  newSession(): void {
    this.emitNewSession.emit();
  }

  toggleLeftPanel(): void {
    this.chatBotService.isLeftPanelOpen.update(prev => !prev);
    this.chatBotService.trackUserAction('Chat history panel toggled');
  }

  toggleBackBtn(): void {
    this.chatBotService.isPromptsPanelOpen.update(prev => !prev);
    this.chatBotService.trackUserAction('Pre-defined Prompts panel closed (View All Prompts)');
  }

  closeChat(): void {
    this.emitCloseChat.emit();
  }
}
